export default __webpack_public_path__ + "static/media/du-vide-desktop.71682295.png";